// System route (/ops/system, Admin); the screen is SystemPage.
import { createFileRoute } from "@tanstack/react-router";

import { SystemPage } from "@/features/operations/SystemPage";

export const Route = createFileRoute("/_app/ops/system")({
  staticData: { crumb: "System" },
  component: SystemPage,
});
